import { gql } from '@apollo/client';

export const GET_LEAGUE_SEASONS = gql`
  query getSeasons($league: leagues_enum) {
    seasons(where: { league: { _eq: $league } }, order_by: { id: desc }) {
      league
      id
      season
      year
    }
  }
`;
